import * as React from 'react';
import { Typography } from '@mui/material';
import {
  RadioButtonGroupInput,
  required,
  TextInput,
  useTranslate,
} from 'react-admin';
import { ScheduleTasksInput } from './ScheduleTasksInput';
import { ProcessTemplateScope } from './types';

const scopeChoices: { id: ProcessTemplateScope; name: string }[] = [
  { id: 'customer', name: 'resources.process-templates.text.scope_customer' },
  { id: 'global', name: 'resources.process-templates.text.scope_global' },
];

export const ProcessTemplateForm = ({ disableScope = false }: { disableScope?: boolean }) => {

  const translate = useTranslate();

  return (
    <>
      <Typography variant="h6">{translate('resources.assets.text.general')}</Typography>
      <RadioButtonGroupInput source="scope" choices={scopeChoices} defaultValue="customer" disabled={disableScope} />
      <TextInput source="processName" validate={required()} />
      <TextInput source="description" validate={required()} multiline />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {translate('resources.process-templates.text.schedule_tasks')}
      </Typography>
      <ScheduleTasksInput source="scheduleTasks" />
    </>
  );

};
